import { createMessageContainer, hideMessages, showMessage } from './form-notification';

function insertSubmitButton(field) {
	const button = document.createElement('button');

	button.innerText = window.LN.i18n.form__button__phone_confirmation;
	button.type = 'button';
	button.classList.add('mdc-button', 'mdc-button--raised');

	field.insertAdjacentElement('afterend', button);

	return button;
}

function initPhoneConfirmations(form) {
	const fields = form.querySelectorAll('[data-form="phoneConfirmation"]');

	fields.forEach(field => {
		const messagesParent = field.closest('[data-form="field"]');
		const messages = createMessageContainer(messagesParent);

		let isMessagesCollapsing = false;

		const button = insertSubmitButton(field);

		button.addEventListener('click', async () => {
			isMessagesCollapsing = hideMessages(messages, isMessagesCollapsing);

			button.disabled = true;

			const response = await fetch('/api/confirmation', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-Requested-With': 'XMLHttpRequest'
				},
				body: JSON.stringify({
					phone: field.value
				})
			})
				.then(response => response.json())
				.catch(error => {
					return {
						error: error.message
					};
				});

			if (response.error) {
				showMessage(messages, response.error, {
					isCollapsing: isMessagesCollapsing,
					error: true,
					keepPosition: true
				});
			} else {
				showMessage(messages, response.message, {
					isCollapsing: isMessagesCollapsing
				});
			}

			button.disabled = false;
		});
	});
}

export { initPhoneConfirmations };
